export default __webpack_public_path__ + "static/media/432hz-inner-healing.0f917697.mp3";